import SelectBox from '../../../components/SelectBox'
import DatePicker from '../../../components/DatePicker'
import CustomSearchBtn from '../../../components/CustomSearchBtn'
import ToggleSwitch from '../../../components/ToggleSwitch'

const FieldWrap = ({ children }) => (
  <div className="inline-flex items-center gap-2 rounded-md dark:bg-white/5 bg-customBlack/5 px-3 py-1 ring-1 dark:ring-white/10 ring-customBlack/10">
    {children}
  </div>
)

const Filters = ({
  date,
  setSortType,
  onDateChange,
  sortType,
  values,
  isMobile,
  handleSearch,
  searchTerm = '',
  onSearchChange = () => {},
  showOddsDetails = false,
  onToggleOddsDetails = () => {},
}) => {

  return (
    <div className="flex flex-wrap items-center gap-3">
      {/* <FieldWrap>
        <svg className="h-5 w-5 dark:text-white/70 text-customBlack/70" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path d="M7 2a1 1 0 011 1v1h8V3a1 1 0 112 0v1h1a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6a2 2 0 012-2h1V3a1 1 0 112 0v1zm12 6H5v10h14V8z" />
        </svg>
        <input
          type="date"
          className="bg-transparent outline-none dark:text-white/90 text-customBlack/90"
          value={date}
          onChange={(e) => onDateChange(e.target.value)}
        />
      </FieldWrap> */}

      <div className='w-44'>
        <DatePicker date={date} setDate={onDateChange} isMobile={isMobile}/>
      </div>

      <CustomSearchBtn handleSearch={handleSearch} extraStyle={"mt-2"} isMobile={isMobile} color='customAccentBlue'/>

      <div className="w-full sm:w-64">
        <label className="sr-only" htmlFor="live-event-search">
          Search events
        </label>
        <input
          id="live-event-search"
          type="search"
          value={searchTerm}
          onChange={(event) => onSearchChange(event.target.value)}
          placeholder="Search events..."
          className="h-10 w-full rounded-md border border-customBlack/10 bg-customBlack/5 px-3 text-sm font-medium text-customBlack outline-none transition placeholder:text-customBlack/45 focus:border-customAccentBlue focus:bg-white focus:ring-2 focus:ring-customAccentBlue/20 dark:border-white/10 dark:bg-white/5 dark:text-white/90 dark:placeholder:text-white/45 dark:focus:bg-custom_dark_secondary"
        />
      </div>

      <div className='w-40'>
        <SelectBox selected={sortType} setSelected={setSortType} options={values} isMobile={isMobile}/>
      </div>

      <ToggleSwitch
        checked={showOddsDetails}
        onChange={onToggleOddsDetails}
        label={isMobile ? 'Odds' : 'Show odds details'}
        size={isMobile ? 'sm' : 'md'}
        className="mt-2 md:mt-0"
      />
    </div>
  )
}

export default Filters
